<section class="">
  <div class="container">
    <div class="row gx-5">
      <div class="d-flex order-md-3 col-12 col-md-7 col-xl-6 align-items-center">
        <div class="">

          <img alt="Adobe Express"
               ngSrc="assets/images/adobe/creative-cloud.svg"
               class="cc-logo"
               height="192"
               width="192"/>

          <h1 class="mt-5">Adobe Creative Cloud Pro</h1>

          @for (app of apps; track app.appName) {
            <img ngSrc="assets/images/adobe/adobe-app-icons/{{app.iconPath}}"
                 width="64"
                 height="64"
                 alt="{{app.appName}}"
                 class="me-2 mt-4">
          }
          <p class="fs-5 fw-bold mt-3">
            Adobe Creative Cloud All Apps Pro is a comprehensive suite that gives
            you access to the entire range of Adobe Creative Cloud applications,
            including industry-leading tools like Photoshop, Illustrator, Premiere
            Pro, InDesign, After Effects and more. Designed for creative
            professionals, students, and educators, these software tools provide
            powerful features for graphic design, video editing, web development,
            photography, and document management. With cloud storage, seamless app
            integration, and regular updates, Adobe Creative Cloud All Apps Pro
            enables users to work efficiently across devices and bring their ideas
            to life with professional-grade tools and resources.
          </p>

          <a routerLink="/adobe/creative-cloud"
             class="btn btn-primary text-uppercase px-5 py-3 fw-bold mb-5">
            Learn More and Request Access
          </a>
        </div>
      </div>

      <div class="d-none order-md-2 col-md-1 d-xl-block"></div>

      <div class="order-md-1 col-12 col-md-5 col-xl-5 d-flex">
        <div class="">
          <img ngSrc="assets/images/adobe/stock-2.jpg"
               alt="one student watches another student draw on a tablet in a computer lab"
               width="440"
               height="522"
               class="img-fluid">
        </div>
      </div>
    </div>
  </div>
</section>
